module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"action":"Visualizar"},"en":{"action":"View"},"es":{"action":"Ver"}}')
  delete Component.options._Ctor
}
